import React, { useEffect, useState } from 'react';

import { Box, Progress, Text, VStack } from '@betterment/samba-react';

type Props = {
  accountRecommendationOption: unknown;
  children: React.ReactNode;
};

export const AccountRecommendationLoadingWrapper: React.FC<Props> = ({ accountRecommendationOption, children }) => {
  const [progress, setProgress] = useState(0);
  const [hasDataArrived, setHasDataArrived] = useState(false);
  const [shouldShowChildren, setShouldShowChildren] = useState(false);

  // Effect 1: Track when data arrives
  useEffect(() => {
    if (accountRecommendationOption !== null && accountRecommendationOption !== undefined) {
      setHasDataArrived(true);
    }
  }, [accountRecommendationOption]);

  // Effect 2: Animate to 40% initially
  useEffect(() => {
    const timeout = setTimeout(() => {
      setProgress(40);
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  // Effect 3: Once data arrives, animate to 100% and then show children
  useEffect(() => {
    if (!hasDataArrived) {
      return undefined;
    }

    // Data arrived, animate to 100%
    setProgress(100);

    // Wait for progress animation to finish (660ms + buffer), then show children
    const timeout = setTimeout(() => {
      setShouldShowChildren(true);
    }, 800);

    return () => clearTimeout(timeout);
  }, [hasDataArrived]);

  if (shouldShowChildren) {
    return <>{children}</>;
  }

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: 'space.400',
      }}
    >
      <VStack css={{ gap: 'space.300', alignItems: 'center', width: '100%', maxWidth: '500px' }}>
        <Text variant="text100" color="text" css={{ fontSize: 16, textAlign: 'center' }}>
          Reviewing your financial profile and accounts
        </Text>
        <Box css={{ width: '100%', height: '8px' }}>
          <Progress value={progress} indicatorColor="background.info.strong" />
        </Box>
      </VStack>
    </Box>
  );
};
